export default function llmevents(state = [], action) {
    switch (action.type) {
      case 'ADD_CURRENT':
        return {
          ...state,
          llmevents: action.llmevent,
        }
      default:
        return state;
    }
}